<template>
  <b-modal
    :visible="visible"
    @hidden="hidden"
    @show="show"
    no-close-on-backdrop
    no-close-on-esc
    hide-header
    hide-footer
    centered
  >
    <b-row class="justify-content-center mb-3">
      <b-col cols="7">
        <service-loading-card
          icon="server"
          :isBusy="loadingDbCreate"
          :isError="errorCreate"
          textBeforeCreated="در حال ایجاد دیتابیس"
          textErrorCreated="دیتابیس ایجاد نشد."
          textAfterCreated="دیتابیس ایجاد شد."
        />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="12" v-if="errorCreate">
        <main-text>
          <b-icon icon="x-circle-fill" variant="danger" class="ml-2"></b-icon>
          متاسفانه خطایی در ایجاد دیتابیس رخ داده است. می‏‌توانید دیتابیس را
          دوباره ایجاد کنید.
        </main-text>
        <error-messages
          :show="errorMessages.length > 0"
          :messages="errorMessages"
        />
        <b-button variant="outline-danger" class="" @click="hidden">
          ایجاد دوباره دیتابیس
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import ServiceLoadingCard from "@/components/ServiceLoadingCard/ServiceLoadingCard.vue";
import { createService } from "@/services/service";
import MainText from "@/components/MainText/MainText.vue";
import { sleep } from "@/utils/functions";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  components: { ServiceLoadingCard, MainText, ErrorMessages },
  name: "CreateDatabaseModal",
  props: {
    visible: { type: Boolean, require: true },
    backupType: { type: Number, require: true }
  },
  data() {
    return {
      loadingDbCreate: false,
      createdDb: false,
      errorCreate: false,
      errorMessages: []
    };
  },
  computed: {
    ...mapState("resource", ["cpu", "ram", "storage"]),
    ...mapState("service", [
      "databaseSelectedVersion",
      "databaseSelectedItem",
      "validServiceName",
      "serviceName",
      "typeService"
    ])
  },
  methods: {
    reset: function() {
      this.loadingDbCreate = false;
      this.createdDb = false;
      this.errorCreate = false;
      this.errorMessages = [];
    },
    hidden: function() {
      this.reset();
      this.$emit("hidden");
    },
    show: function() {
      this.$emit("show");
      document.getElementById("scroll-area").scrollTo(0, 0);
      this.createDatabaseService();
    },
    createDatabaseService: async function() {
      ;
      this.loadingDbCreate = true;
      const [error, data] = await createService({
        serviceId: this.databaseSelectedVersion,
        cpu: this.cpu.value,
        ram: this.ram.value,
        storage: this.storage.value,
        backupType: this.backupType
      });
      if (error) {
        this.loadingDbCreate = false;
        this.errorCreate = true;
        this.errorMessages = error;
      } else {
        if (data.apiStatus === 200) {
          this.loadingDbCreate = false;
          this.createdDb = true;
          await sleep(2000);
          this.$router.push(`/database/${data.apiData.serviceId}/details`);
        } else {
          this.loadingDbCreate = false;
          this.errorCreate = true;
          this.errorMessages = data.apiErrors;
        }
      }
    }
  }
};
</script>
